import { MATERIAL_FILTER_PARAM } from '$constants'

export const createPMDDeepLink = (materialId, material_name = null) => {
  const baseUrl = '/partsmasterdata'
  const params = new URLSearchParams()
  params.set(MATERIAL_FILTER_PARAM, materialId)

  if (material_name) {
    params.set('material_name', material_name)
  }

  return `${baseUrl}?${params.toString()}`
}

export const parseMaterialFilterFromUrl = (searchParams) => {
  return searchParams.get(MATERIAL_FILTER_PARAM)
}

export const parseMaterialNameFromUrl = (searchParams) => {
  const name = searchParams.get('material_name')
  return name ? decodeURIComponent(name) : null
}
